document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia("(max-width: 768px)").matches) return;

  let isInteractingWithSelect = false;

  // Detectar interacción táctil con <select>
  document.addEventListener('touchstart', function (e) {
    if (e.target && e.target.tagName === 'SELECT') {
      isInteractingWithSelect = true;
      setTimeout(() => isInteractingWithSelect = false, 1000); // se resetea en 1 segundo
    }
  });

  const changeFirstOptionText = (selectElements) => {
    if (!selectElements || selectElements.length === 0) return;

    for (let select of selectElements) {
      if (select?.options?.length > 0) {
        const firstOption = select.options[0];
        if (firstOption.text !== "Subscribe & Save") {
          firstOption.text = "Subscribe & Save";
          firstOption.disabled = true;
        }
      }
    }
  };

  const debounce = (func, wait) => {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  };

  const processChanges = debounce(() => {
    if (isInteractingWithSelect) return;

    const selects = document.querySelectorAll('.product-item .plp-btns-reverse #product-item-recharge-select');
    if (selects.length > 0) {
      changeFirstOptionText(selects);
    }
  }, 100);

  const initialSelects = document.querySelectorAll('.product-item .plp-btns-reverse #product-item-recharge-select');
  changeFirstOptionText(initialSelects);

  const productContainer = document.querySelector('.product-item')?.closest('.grid') || document.body;

  const observer = new MutationObserver((mutationsList) => {
    if (isInteractingWithSelect) return;

    for (let mutation of mutationsList) {
      if (mutation.addedNodes.length > 0 || mutation.type === 'childList') {
        processChanges();
        return;
      }
    }
  });

  observer.observe(productContainer, {
    childList: true,
    subtree: true
  });

  // Desconecta el observer tras 10s si ya hay selects válidos
  setTimeout(() => {
    const finalSelects = document.querySelectorAll('.product-item .plp-btns-reverse #product-item-recharge-select');
    changeFirstOptionText(finalSelects);

    if (finalSelects.length > 0) {
      observer.disconnect();
    }
  }, 10000);
}); 